/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PermissionDto } from '../models/permission-dto';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation permissionsGetPermissions
   */
  static readonly PermissionsGetPermissionsPath = '/v1/admin/permissions';

  /**
   * Get permissions list.
   *
   * Use this method to get the list of available permissions
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `permissionsGetPermissions()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionsGetPermissions$Response(params?: {
  }): Observable<StrictHttpResponse<Array<PermissionDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PermissionsService.PermissionsGetPermissionsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<PermissionDto>>;
      })
    );
  }

  /**
   * Get permissions list.
   *
   * Use this method to get the list of available permissions
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `permissionsGetPermissions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  permissionsGetPermissions(params?: {
  }): Observable<Array<PermissionDto>> {

    return this.permissionsGetPermissions$Response(params).pipe(
      map((r: StrictHttpResponse<Array<PermissionDto>>) => r.body as Array<PermissionDto>)
    );
  }

}
